export interface EarnedReward {
  id: number;
  reward_code: string;
  reward_kind: 'GIFT_CARD_CREDIT' | 'FREE_ITEM' | 'DISCOUNT';
  amount: number;
  status: 'ACTIVE' | 'REDEEMED' | 'EXPIRED' | 'REVOKED';
  expires_at: string;
  created_at: string;
  offer_title: string;
  offer_description: string;
  min_next_order_spend: number;
  earned_from_order_hash: string;
  earned_order_counter: string;
  credit_balance?: number;
  free_item_name?: string;
  free_item_category?: string;
  free_item_portion?: string;
  free_item_menu_item_id?: number;
}

export interface MyRewardsResponse {
  active: EarnedReward[];
  history: EarnedReward[];
}

export interface EarnProgressCondition {
  name: string;
  quantity_in_cart: number;
  quantity_required: number;
  met: boolean;
}

export interface EarnProgressItem {
  offer_id: number;
  offer_title: string;
  offer_description: string;
  reward_description: string;
  trigger_type: 'SPEND' | 'ITEM' | 'CATEGORY';
  qualified: boolean;
  spend_current?: number;
  spend_threshold?: number;
  spend_remaining?: number;
  mode?: 'OR' | 'AND' | 'SPLIT';
  conditions?: EarnProgressCondition[];
}

export interface ImmediateSuggestion {
  offer_id: number;
  offer_title: string;
  promo_code: string;
  offer_value: string;
}

export interface EarnProgressResponse {
  progress: EarnProgressItem[];
  selected_offer_id: number | null;
  immediate_suggestions: ImmediateSuggestion[];
}

export function earnedRewardSummary(reward: EarnedReward): string {
  switch (reward.reward_kind) {
    case 'GIFT_CARD_CREDIT':
      return `$${(+(reward.credit_balance != null ? reward.credit_balance : reward.amount)).toFixed(2)} store credit`;
    case 'FREE_ITEM':
      return reward.free_item_name ? `Free ${reward.free_item_name}` : 'a free item';
    case 'DISCOUNT':
      return `$${(+reward.amount).toFixed(2)} off`;
    default:
      return reward.offer_title || 'a reward';
  }
}
